import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { GetCompaniesResponse, GetWidgetsForDashboardResponse } from '@nirvana/shared/dtos/types/dashboards/gz-console';
import {
  GetExecutiveSummaryPdfRequest,
  GetExecutiveSummaryPdfResponse,
} from '@nirvana/shared/dtos/types/dashboards/common';
import { TimeRange } from '@nirvana/shared/dtos/types/shared/time';

export class DashboardBaseDataProvider extends BaseWebComponentDataProvider {
  async setTimeRange(params: { dashboardId: string; timeRange: TimeRange }): Promise<{} | undefined> {
    throw new Error('Needs to be implemented');
  }

  async setTargets(params: { dashboardId: string; targets: Array<string> }): Promise<{} | undefined> {
    throw new Error('Needs to be implemented');
  }

  async getWidgetsForDashboard(params: { dashboardId: string }): Promise<GetWidgetsForDashboardResponse | undefined> {
    throw new Error('Needs to be implemented');
  }

  async getCompanies(params: { companyName: string }): Promise<GetCompaniesResponse | undefined> {
    throw new Error('Needs to be implemented');
  }

  async getExecutiveSummaryPdf(params: GetExecutiveSummaryPdfRequest): Promise<GetExecutiveSummaryPdfResponse> {
    throw new Error('Needs to be implemented');
  }
}
